<template>
  <div class="number-container">
    <p class="title-news mb-30">已邀请好友</p>
    <el-row>
      <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="item in list" :key="item.userId">
        <img v-if="item.avatar" :src="item.avatar" alt="">
        <icon-svg v-else :icon-class="$store.state.user.userInfo.gender === 2 ? 'defaultWoman' : 'defaultMan'" class="head-default"></icon-svg>
        <div class="user-info">
          <p class="name ellipsis">{{item.nickname}}</p>
          <p class="company ellipsis">{{item.stockjobber}}</p>
        </div>
      </el-col>
      <div v-infinite-scroll="loadMore" :infinite-scroll-disabled="busy" :infinite-scroll-immediate-check="false" infinite-scroll-distance="10"  infinite-scroll-throttle-delay="300"></div>
      <loading v-show="loading" />
    </el-row>
  </div>
</template>
<script>
import { getInviterUser } from '@/api/user'
export default {
  data () {
    return {
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      busy: false,
      loading: true
    }
  },
  created () {
    this.getListData()
  },
  methods: {
    loadMore () {
      if ((this.pageNum > 1 && this.pageNum > Math.ceil(this.total / this.pageSize)) || this.busy) return
      // 多次加载数据
      this.getListData()
    },
    getListData () {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userId: this.userId,
        commentNum: this.commentCount,
        launchTime: this.launchTime,
        state: this.state
      }
      this.loading = true
      this.busy = true
      getInviterUser(params).then(response => {
        const { data } = response
        if (this.pageNum === 1) {
          this.total = data.total
          this.list = []
        }
        this.pageNum++
        this.list = this.list.concat(data.list)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
        this.busy = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.number-container{
  border: $border;
  padding: 26px 30px 0;
  border-radius:8px;
  .title-news{
    font-size: 20px;
  }
}
.el-col{
  border-top: $border;
  padding: 28px 10px 28px 0;
  display: flex;
  img,.head-default{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .user-info{
    overflow: hidden;
    .name{
      color: #383838;
      font-size: 16px;
      line-height: 34px;
    }
    .company{
      color: #929292;
      line-height: 22px;
    }
  }
}
</style>
